<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
  >
    <template slot="select-header">
      {{ letter.selectPayment }}
    </template>
    <template slot="select-content">
      <List class="payment-select-container j-payment-select-container">
        <ListItem
          class="areas-lst select-items"
          type="paymentItem"
          pointClass="j-select-money"
          :active="price.TRANS_AMOUNT == curPrice.TRANS_AMOUNT"
          @click="selectPayMent(price)"
          v-for="(price, index) in pricesList"
          :key="index"
        >
          {{ changePriceFormat(price) }}
          {{ curPayType ? curPayType.show_currency : '' }}
          <template v-if="!isGsOrSupPayAutoSelect">
            =
            {{ getProductName(curProduct) }}
            <template v-if="+curProduct.PRODUCT_EXTRA_COIN > 0">
              + {{ curProduct.PRODUCT_EXTRA_COIN }}
              {{ coinName }}
            </template>
            <template v-if="+price.SUB_COIN > 0">
              +
              {{ price.SUB_COIN }}
              {{ subCoinNama }}
            </template>
            <template v-if="+price.EXTRA_COIN > 0">
              +
              {{ price.EXTRA_COIN }}
              {{ extraCoinName }}
            </template>
          </template>
        </ListItem>
      </List>
    </template>
  </SelectContianer>
</template>
<script>
import selectContainer from '@mixins/officialStore/selectContainer';
import { changePriceFormat } from '@utiles/officialStore';
import { mapGetters } from 'vuex';
import product from '@mixins/product';
import gsOperate from '@mixins/officialStore/gsOperate';
export default {
  data() {
    return {
      totalCount: 0
    };
  },
  props: ['pricesList', 'curPrice', 'curPayType', 'curProduct'],
  mixins: [selectContainer, product, gsOperate],
  computed: {
    coinName() {
      return this.$store.state.coin_name;
    },
    ...mapGetters([
      'subCoinNama',
      'extraCoinName',
      'directPayCoinName',
      'directPayExtraCoinName'
    ])
  },
  methods: {
    selectPayMent(price) {
      this.$emit('selectPayMent', price);
    },
    changePriceFormat(price) {
      if (price !== undefined) {
        return changePriceFormat(price.CURRENCY, price.TRANS_AMOUNT);
      }
      return price && price.TRANS_AMOUNT;
    }
  }
};
</script>
<style lang="scss" scoped>
.select-items {
  align-items: center;
  line-height: 50px;
}
@media screen and (orientation: landscape) {
  .select-items {
    line-height: 80px;
  }
}
</style>
